/**
 * @generated SignedSource<<cae5dae4faec897ae0e12c1b92ff5c8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fontSize"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "unit"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "value"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "fontSize",
        "variableName": "fontSize"
      },
      {
        "kind": "Variable",
        "name": "unit",
        "variableName": "unit"
      },
      {
        "kind": "Variable",
        "name": "value",
        "variableName": "value"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "updateDefaultFont",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateDefaultFontMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpdateDefaultFontMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "a87c2403e7a996806d7cf2bacd1aa5de",
    "id": null,
    "metadata": {},
    "name": "UpdateDefaultFontMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateDefaultFontMutation(\n  $value: String!\n  $fontSize: Int!\n  $unit: String!\n) {\n  updateDefaultFont(value: $value, fontSize: $fontSize, unit: $unit) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "e96d7f9b4e06f39fb390d71339382f1c";

export default node;
